module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-common-attributes"
  }, [_c('p', {
    staticClass: "top-common-attributes__title"
  }, [_vm._v("Top 10 by coverage")]), _vm._v(" "), _c('div', {
    staticClass: "top-common-attributes__y-title"
  }, [_vm._v("Index to average")]), _vm._v(" "), _c('div', {
    staticClass: "top-common-attributes__x-title"
  }, [_vm._v("Coverage")]), _vm._v(" "), _c('top-attributes-bubble-graph', {
    ref: "graph",
    staticClass: "top-common-attributes__graph",
    attrs: {
      "chartData": _vm.dataForGraph,
      "axises": _vm.axises
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32105d9a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/topCommonAttributes/TopCommonAttributes.vue
// module id = 2034
// module chunks = 0